import { AttacherNode, AttacherNodesByModelId } from "@animech/supermodel";
import {
	AttacherAttributeMap,
	BaseAttributeDefinition,
	BaseAttributeDefinitions as BaseAttributeDefinitions,
} from "./attacher-attribute-map";

type AttributeValueType<AttributeDefinition extends BaseAttributeDefinition> =
	| keyof AttributeDefinition["values"]
	| AttributeDefinition["defaultValue"];

export type AttributeBond<AttributeType extends string, T> = Partial<
	Record<AttributeType, Partial<Record<AttributeType, T>>>
>;

const familyAttributeDefinition = {
	defaultValue: "none",
	values: {},
} as const satisfies BaseAttributeDefinition;

export const attacherAttributeDefinitions = {
	family: familyAttributeDefinition,
} as const satisfies BaseAttributeDefinitions;

export type FamilyType = AttributeValueType<typeof familyAttributeDefinition>;

export class DefinedAttacherAttributeMap extends AttacherAttributeMap<
	typeof attacherAttributeDefinitions,
	keyof typeof attacherAttributeDefinitions
> {
	constructor(
		attacherNodesByModelId: AttacherNodesByModelId,
		dynamicAttacherNodesByEntityName: Record<string, AttacherNode[]>,
	) {
		super(
			attacherNodesByModelId,
			dynamicAttacherNodesByEntityName,
			attacherAttributeDefinitions,
		);
	}
}
